import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import SmartRetailLinks from '@/plugins/graphql/queries/v2/referral/smart-retail-links-by-app.gql';
import SmartRetailLinksCount from '@/plugins/graphql/queries/v2/referral/smart-retail-links-count.gql';
import { ReferralLinkModel } from '@/helpers/entities/models/ReferralLinkModel';
import { Getter } from 'vuex-class';
let SmartRetailLinksManager = class SmartRetailLinksManager extends Mixins() {
    constructor() {
        super(...arguments);
        this.keyword = null;
        this.smartRetailLinks = [];
        this.count = 0;
    }
    get queryOnFlight() {
        return this.$apollo.queries.smartRetailLinks.loading;
    }
};
__decorate([
    Getter('appUuid')
], SmartRetailLinksManager.prototype, "appUuid", void 0);
__decorate([
    Prop({ type: String, required: false })
], SmartRetailLinksManager.prototype, "keyword", void 0);
SmartRetailLinksManager = __decorate([
    Component({
        apollo: {
            smartRetailLinks: {
                query: SmartRetailLinks,
                variables() {
                    return {
                        appUuid: this.appUuid,
                        keyword: this.keyword,
                    };
                },
                fetchPolicy: 'cache-and-network',
                update(data) {
                    const smartRetailLinks = data.smartRetailLinksByApp.edges;
                    const smartRetailLinksNodes = (smartRetailLink) => {
                        return new ReferralLinkModel(smartRetailLink.node);
                    };
                    return smartRetailLinks.map(smartRetailLinksNodes);
                },
            },
            count: {
                query: SmartRetailLinksCount,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    return data.smartRetailLinksCount;
                },
            },
        },
    })
], SmartRetailLinksManager);
export default SmartRetailLinksManager;
